import CssAdmin from './CssAdmin'

export default CssAdmin
